import { __rest } from './../external/.pnpm/@rollup_plugin-typescript@10.0.1_rollup@3.25.1_tslib@2.5.3_typescript@4.9.5/external/tslib/tslib.es6.js';
import { _mapValues } from './mapValues.js';
import { _isPlainObject } from './isPlainObject.js';

function handleArray(value) {
    return function (propVal) {
        if (_isPlainObject(propVal)) {
            const _a = deepSet(propVal, value), field = __rest(_a, ["key"]);
            return field;
        }
        return value;
    };
}
/**
 * @category Helper
 */
function deepSet(obj, value) {
    return _mapValues(obj, (prop) => _isPlainObject(prop)
        ? deepSet(prop, value)
        : Array.isArray(prop)
            ? prop.map(handleArray(value))
            : value);
}

export { deepSet };
//# sourceMappingURL=deepSet.js.map
